"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedemptionService = void 0;
const RedemptionServiceLive_1 = require("./RedemptionServiceLive");
const RedemptionServiceStub_1 = require("./RedemptionServiceStub");
class RedemptionService {
    static create(stub = false) {
        if (stub) {
            return new RedemptionServiceStub_1.RedemptionServiceStub();
        }
        return new RedemptionServiceLive_1.RedemptionServiceLive();
    }
}
exports.RedemptionService = RedemptionService;
//# sourceMappingURL=RedemptionService.js.map